<div class="container pt-4 d-none d-lg-block">
  <button class="back-btn d-flex align-items-center justify-content-center" (click)="goBack()" aria-label="Back">
    <span class="material-icons text-white">arrow_back_ios</span>
  </button>
</div>

<!--Mobile Navigation-->
<fgb-mobile-nav-menu
  [pageName]="'wallet.claimed.page.title' | translate"
  [showHamburger]="false"
  [showWalletButton]="false"
></fgb-mobile-nav-menu>

<div class="bg-primary d-lg-none mobile-header-background"></div>
<div class="container mobile-page-content">
  <div class="d-flex align-items-center pt-20 pb-10">
    <!-- Title -->
    <h5 class="m-0 font-size-18 wallet-redeemed-title">{{ 'wallet.redeemed.title' | translate }}</h5>
  </div>
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [style]="'list'"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="border rounded">
    <div class="font-size-12 text-center py-3">
      {{ 'claimed.rewards.placeholder.description' | translate }}
    </div>
  </div>
</ng-template>
